const content = {
  tagline: '',
  title: 'Florian Wojtenek',
  subtitle: 'React, GraphQL, ASP.Net & Keyboard 🤘',
};

export default content;
